import React, { FunctionComponent } from 'react';
import { ApolloProvider as ApolloProviderBase } from 'react-apollo';
import ApolloClient from './ApolloClient';

export const client = new ApolloClient();

const ApolloProvider: FunctionComponent = ({ children }) => <ApolloProviderBase client={client} children={children} />;

export default ApolloProvider;
